import { createFileRoute } from "@tanstack/react-router";

import { ShophomePreviewPanel } from "@/features/xapi/shophome-preview-panel";

export const Route = createFileRoute("/_authenticated/nikeapp/shophome")({
  component: ShophomePreviewRoute,
});

function ShophomePreviewRoute() {
  return <ShophomePreviewPanel />;
}
